//src/app/services/conversations/index.tsx
import api, {
  buildQueryParams,
  ICursorPaginatedParams,
  ICursorPaginatedResponse,
  IEnhancedCursorPaginatedResponse,
  IGetQueryParams,
} from '..';
import { IConversation, IMessage } from '../messages';

const e = api.injectEndpoints({
  endpoints: (builder) => ({
    getConversationById: builder.query<IConversation, number>({
      query: (id) => `/conversations/${id}/temp/show`,
      transformResponse: (res: { conversation: IConversation }) =>
        res.conversation,
      providesTags: [{ type: 'Conversation', id: 'Active' }],
    }),

    getPaginatedConversations: builder.query<
      IEnhancedCursorPaginatedResponse<IConversation>,
      IGetQueryParams<{
        stared?: boolean;
        archived?: boolean;
        title_search: string;
        client_id?: string;
        read?: boolean;
      }>
    >({
      query: (params) =>
        params.filters.client_id
          ? `/conversations/client/${
              params.filters.client_id
            }${buildQueryParams(params)}`
          : `/conversations/temp_c/index${buildQueryParams(params)}`,
      providesTags: [{ type: 'Conversations' }],
    }),

    getConversationMessages: builder.query<
      ICursorPaginatedResponse<IMessage>,
      {
        conversationId: number;
        setAsRead?: boolean;
        client_id?: string;
      } & ICursorPaginatedParams
    >({
      query: (params) =>
        `conversations/${params.conversationId}/temp/messages${buildQueryParams(
          params,
        )}${params.setAsRead ? '&set_as_read=true' : ''}`,
    }),
    archiveConversation: builder.mutation<
      IConversation,
      { conversationId: number; setAsArchived: boolean }
    >({
      query: ({ conversationId, setAsArchived }) => ({
        url: `/conversations/${conversationId}/${
          setAsArchived ? 'archive' : 'unarchive'
        }`,
        method: 'POST',
      }),
      invalidatesTags: [
        { type: 'Conversation', id: 'Active' },
        { type: 'Conversations' },
      ],
      transformResponse: (response: { conversation: IConversation }) =>
        response.conversation,
    }),

    starConversation: builder.mutation<
      IConversation,
      { conversationId: number; setAsStarred: boolean }
    >({
      query: ({ conversationId, setAsStarred }) => ({
        url: `/conversations/${conversationId}/${
          setAsStarred ? 'star' : 'unstar'
        }`,
        method: 'POST',
      }),
      transformResponse: (response: { conversation: IConversation }) =>
        response.conversation,
    }),
  }),
});

export const {
  useLazyGetConversationMessagesQuery,
  useGetConversationByIdQuery,
  useLazyGetConversationByIdQuery,
  useGetPaginatedConversationsQuery,
  useArchiveConversationMutation,
  useStarConversationMutation,
  useLazyGetPaginatedConversationsQuery,
} = e;
